import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ml',
    fullName: 'Malayalam',
    nativeName: 'മലയാളം',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "അത്ഭുതകരമായ സംഗതി വരുന്നു",
    landing_subtitle: "ArgVoid ഒരു ആപ്പും ഗെയിം ഡെവലപ്‌മെൻ്റ് സ്റ്റുഡിയോയുമാണ്. തുടരുക, പുതിയ കാര്യങ്ങൾ ഉടൻ വരുന്നു!",
    select_language: "ഭാഷ തിരഞ്ഞെടുക്കുക",
    search_placeholder: "ഭാഷകൾ തിരയുക...",
    terms_title: "സേവന നിബന്ധനകൾ",
    policy_title: "സ്വകാര്യതാ നയം",
    cookies_title: "കുക്കി നയം",
    terms_content: `
        <strong>1. നിബന്ധനകളുടെ സ്വീകാര്യത</strong><br>
        ArgVoid ആക്സസ് ചെയ്യുന്നതിലൂടെ, ഈ സേവന നിബന്ധനകൾ അംഗീകരിക്കപ്പെടുന്നു. ഈ നിബന്ധനകൾ അംഗീകരിക്കുന്നില്ലെങ്കിൽ, സേവനം ഉപയോഗിക്കാൻ പാടില്ല.<br><br>

        <strong>2. പ്ലാറ്റ്ഫോം ഉപയോഗം</strong><br>
        വിവരദായകവും ക്രിയാത്മകവുമായ ആവശ്യങ്ങൾക്കായി ArgVoid ഉം അതിൻ്റെ ആപ്ലിക്കേഷനുകളും "ഉള്ളതുപോലെ" നൽകിയിരിക്കുന്നു. നിയമാനുസൃതമായ ആവശ്യങ്ങൾക്ക് മാത്രമേ സേവനം ഉപയോഗിക്കാവൂ.<br><br>

        <strong>3. നിരോധിത പെരുമാറ്റം</strong><br>
        സൈറ്റിലെ കേടുപാടുകൾ ചൂഷണം ചെയ്യുകയോ സ്പാമിംഗ് ചെയ്യുകയോ അടിസ്ഥാന സൗകര്യങ്ങളിലേക്കുള്ള അനധികൃത പ്രവേശനം ശ്രമിക്കുകയോ ചെയ്യുന്നത് കർശനമായി നിരോധിച്ചിരിക്കുന്നു.<br><br>

        <strong>4. നിരാകരണം</strong><br>
        പ്ലാറ്റ്‌ഫോമും സേവനങ്ങളും എപ്പോൾ വേണമെങ്കിലും അറിയിപ്പ് കൂടാതെ പരിഷ്‌ക്കരിച്ചേക്കാം. സേവനത്തിൻ്റെ പ്രവർത്തന സമയത്തെക്കുറിച്ചോ ലഭ്യതയെക്കുറിച്ചോ വാറൻ്റി നൽകിയിട്ടില്ല.
    `,
    policy_content: `
        <strong>1. വിവര ശേഖരണം</strong><br>
        പ്ലാറ്റ്‌ഫോമിന് ഇപ്പോൾ ഉപയോക്തൃ പ്രാമാണീകരണമോ അക്കൗണ്ട് സൃഷ്‌ടിക്കലോ ആവശ്യമില്ല. വ്യക്തിഗത തിരിച്ചറിയൽ വിവരങ്ങളൊന്നും (പേരുകൾ അല്ലെങ്കിൽ ഇമെയിൽ വിലാസങ്ങൾ പോലുള്ളവ) സന്ദർശകരിൽ നിന്ന് സജീവമായി ശേഖരിക്കുന്നില്ല.<br><br>

        <strong>2. ഉപയോഗ ഡാറ്റ</strong><br>
        സൈറ്റ് ട്രാഫിക് മനസ്സിലാക്കുന്നതിനും ആപ്ലിക്കേഷനുകൾ മെച്ചപ്പെടുത്തുന്നതിനും അടിസ്ഥാന, അജ്ഞാത വിശകലനങ്ങൾ ശേഖരിക്കപ്പെട്ടേക്കാം. ഈ ഡാറ്റ വ്യക്തിഗത ഉപയോക്തൃ ഐഡൻ്റിറ്റികളുമായി ലിങ്ക് ചെയ്തിട്ടില്ല.<br><br>

        <strong>3. മൂന്നാം കക്ഷി സേവനങ്ങൾ</strong><br>
        ഹോസ്റ്റിംഗിനും അനലിറ്റിക്‌സ് സേവനങ്ങൾക്കുമായി മൂന്നാം കക്ഷി ദാതാക്കളെ ഉപയോഗിച്ചേക്കാം. ഈ ബന്ധപ്പെട്ട ദാതാക്കളുടെ സ്വകാര്യതാ രീതികൾ അവരുടെ ഇൻഫ്രാസ്ട്രക്ചറിൽ പ്രോസസ്സ് ചെയ്ത അജ്ഞാത ഡാറ്റയെ നിയന്ത്രിക്കുന്നു.<br><br>

        <strong>4. ഡാറ്റ സെക്യൂരിറ്റി</strong><br>
        പ്ലാറ്റ്‌ഫോം സംരക്ഷിക്കുന്നതിന് ന്യായമായ സുരക്ഷാ നടപടികൾ നടപ്പിലാക്കുന്നു. എന്നിരുന്നാലും, ഇൻറർനെറ്റിലൂടെ സംപ്രേഷണം ചെയ്യുന്ന ഒരു രീതിയും പൂർണ്ണമായും സുരക്ഷിതമല്ല.<br><br>
    `,
    cookies_content: `
        <strong>1. കുക്കികളും ലോക്കൽ സ്റ്റോറേജും എന്താണ്?</strong><br>
        സന്ദർശനങ്ങളിലുടനീളമുള്ള കോൺഫിഗറേഷൻ മുൻഗണനകൾ ഓർക്കാൻ ഉപകരണത്തിൽ സംഭരിച്ചിരിക്കുന്ന ചെറിയ ഡാറ്റ ഫയലുകളാണ് കുക്കികളും ബ്രൗസർ ലോക്കൽ സ്റ്റോറേജും.<br><br>

        <strong>2. ഉപയോഗ ഉദ്ദേശ്യം</strong><br>
        കോൺഫിഗറേഷൻ ക്രമീകരണങ്ങൾ സംരക്ഷിക്കാൻ ബ്രൗസർ ലോക്കൽ സ്റ്റോറേജ് കർശനമായി ഉപയോഗിക്കുന്നു, ഉദാഹരണത്തിന്:<br>
        - ഭാഷാ മുൻഗണനകൾ<br>
        - ഉപയോക്തൃ ഇൻ്റർഫേസ് കോൺഫിഗറേഷൻ (ഉദാ. ലേഔട്ട് അല്ലെങ്കിൽ തീം ക്രമീകരണങ്ങൾ)<br>
        - താൽക്കാലിക ആപ്ലിക്കേഷൻ കാഷെ<br><br>

        <strong>3. </strong><br> ട്രാക്കിംഗ് ഇല്ല
        കുക്കികളും പ്രാദേശിക സംഭരണവും പരസ്യത്തിനോ മൂന്നാം കക്ഷി ട്രാക്കിംഗ് ആവശ്യങ്ങൾക്കോ ഉപയോഗിക്കുന്നില്ല. സംഭരിച്ചിരിക്കുന്ന എല്ലാ ഡാറ്റയും പ്ലാറ്റ്‌ഫോമിൻ്റെ പ്രധാന പ്രവർത്തനത്തിന് വേണ്ടിയുള്ളതാണ്.<br><br>

        <strong>4. കൺട്രോൾ</strong><br>
        ബ്രൗസർ ക്രമീകരണങ്ങൾ വഴി ബ്രൗസർ ഡാറ്റ എപ്പോൾ വേണമെങ്കിലും മായ്‌ക്കാനാകും, ഇത് ഏതെങ്കിലും പ്രാദേശിക കോൺഫിഗറേഷനുകൾ പുനഃസജ്ജമാക്കും.
    `,
    cookie_consent_text: "നിങ്ങളുടെ സെഷൻ സജീവമായി നിലനിർത്തുക, നിങ്ങളുടെ ഭാഷാ മുൻഗണന സംരക്ഷിക്കുക, മറ്റ് ഇഷ്‌ടാനുസൃത കോൺഫിഗറേഷനുകൾ എന്നിവ പോലുള്ള വെബ്‌സൈറ്റ് പ്രവർത്തനങ്ങൾ ശരിയായി ഉറപ്പാക്കാൻ ഞങ്ങൾ അടിസ്ഥാന കുക്കികൾ ഉപയോഗിക്കുന്നു.",
    read_policy: "കുക്കി നയം വായിക്കുക",
    support_title: "പിന്തുണയുമായി ബന്ധപ്പെടുക",
    support_subject_label: "വിഷയം",
    support_message_label: "സന്ദേശം",
    support_submit_button: "സന്ദേശം അയയ്‌ക്കുക",
    support_hint: "ശ്രദ്ധിക്കുക: സന്ദേശം അയയ്‌ക്കുന്നതിന് ഇത് നിങ്ങളുടെ സ്ഥിരസ്ഥിതി ഇമെയിൽ ആപ്ലിക്കേഷൻ തുറക്കും.",
    support_success_msg: "നിങ്ങളുടെ ഇമെയിൽ ആപ്പ് തുറക്കുന്നു...",
    support_error_msg: "സന്ദേശം അയയ്‌ക്കുന്നതിൽ പരാജയപ്പെട്ടു. ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക.",
    explorer_title: "എക്സ്പ്ലോറർ",
    history_title: "ചരിത്രം",
    animation_title: "ആനിമേഷൻ",
    config_title: "കോൺഫിഗറേഷൻ",
    tool_mouse: "തിരഞ്ഞെടുക്കുക (Ctrl+M)",
    tool_brush: "ബ്രഷ് (Ctrl+B)",
    tool_brush_mode: "ടോഗിൾ മോഡ് (ഖര/വ്യക്തം)",
    tool_eraser: "ഇറേസർ (Ctrl+E)",
    tool_brush_size: "ബ്രഷ് വലുപ്പം ക്രമീകരിക്കുക",
    tool_bucket: "പൂരിപ്പിക്കുക (Ctrl+F)",
    tool_eyedropper: "ഐഡ്രോപ്പർ",
    tool_grid: "ഗ്രിഡ് (Ctrl+Shift+B)",
    tool_rotate: "തിരിക്കുക (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "ഫ്ലിപ്പ് വി (Ctrl+Shift+V)",
    tool_transpose: "ട്രാൻസ്പോസ് ചെയ്യുക (Ctrl+Shift+T)",
    label_width: "വീതി",
    label_height: "ഉയരം",
    label_frames: "ഫ്രെയിമുകളുടെ എണ്ണം",
    label_animation: "ആനിമേഷൻ ശൈലി",
    label_background_color: "പശ്ചാത്തല നിറം",
    label_interval: "ഇടവേള",
    tool_anim_config: "ആനിമേഷൻ കോൺഫിഗറേഷൻ",
    label_new_width: "പുതിയ വീതി",
    label_new_height: "പുതിയ ഉയരം",
    label_apply: "അപേക്ഷിക്കുക",
    label_colors: "നിറങ്ങൾ",
    label_size: "വലിപ്പം",
    label_tolerance: "സഹിഷ്ണുത",
    val_horizontal: "തിരശ്ചീനമായി",
    val_vertical: "ലംബമായ",
    val_sequence: "ക്രമം",
    val_bounce: "ബൗൺസ്",
    val_random: "ക്രമരഹിതം",
    val_solid: "സോളിഡ്",
    val_clear: "ക്ലിയർ",
    action_add_sheet: "പുതിയ ഷീറ്റ്",
    action_import: "ഇറക്കുമതി ചെയ്യുക",
    action_export: "കയറ്റുമതി",
    action_sort_projects: "അടുക്കുക",
    sort_date_old: "ഏറ്റവും പഴയ ആദ്യ",
    sort_date_new: "ഏറ്റവും പുതിയത് ആദ്യം",
    sort_name_az: "പേര് (A-Z)",
    sort_name_za: "പേര് (Z-A)",
    action_new_sprite: "പുതിയ സ്പ്രൈറ്റ്",
    action_new_project: "പുതിയ പദ്ധതി",
    modal_save_all_title: "എല്ലാ മാറ്റങ്ങളും സംരക്ഷിക്കുക",
    modal_save_all_desc: "സംരക്ഷിക്കാൻ അസറ്റുകൾ തിരഞ്ഞെടുക്കുക:",
    modal_save_selected: "തിരഞ്ഞെടുത്തവ സംരക്ഷിക്കുക",
    action_saved: "സംരക്ഷിച്ചു",
    modal_create_sprite_title: "പുതിയ സ്പ്രൈറ്റ് സൃഷ്ടിക്കുക",
    modal_create_project_title: "പുതിയ പ്രോജക്റ്റ് സൃഷ്ടിക്കുക",
    modal_add_sheet_title: "പുതിയ ഷീറ്റ് ചേർക്കുക",
    modal_rename_sheet_title: "ഷീറ്റിൻ്റെ പേര് മാറ്റുക",
    modal_rename_sprite_title: "സ്പ്രൈറ്റ് പുനർനാമകരണം ചെയ്യുക",
    modal_delete_sprite_title: "സ്പ്രൈറ്റ് ഇല്ലാതാക്കുക",
    modal_delete_project_title: "പദ്ധതി ഇല്ലാതാക്കുക",
    modal_delete_sheet_title: "ഷീറ്റ് ഇല്ലാതാക്കുക",
    placeholder_sprite_name: "പേര്",
    placeholder_project_name: "പേര്",
    placeholder_sheet_name: "പേര്",
    placeholder_new_name: "പുതിയ പേര്",
    action_create: "സൃഷ്ടിക്കുക",
    action_add: "ചേർക്കുക",
    action_rename: "പേരുമാറ്റുക",
    action_duplicate: "ഡ്യൂപ്ലിക്കേറ്റ്",
    action_delete: "ഇല്ലാതാക്കുക",
    action_cancel: "റദ്ദാക്കുക",
    confirm_delete_sprite: "ഈ സ്‌പ്രൈറ്റ് ഇല്ലാതാക്കണമെന്ന് തീർച്ചയാണോ?",
    confirm_delete_project: "ഈ പ്രോജക്റ്റ് ഇല്ലാതാക്കണമെന്ന് തീർച്ചയാണോ? എല്ലാ സ്പ്രിറ്റുകളും നീക്കംചെയ്യപ്പെടും.",
    confirm_delete_sheet: "ഈ ഷീറ്റ് ഇല്ലാതാക്കണമെന്ന് തീർച്ചയാണോ?",
    err_select_sprite: "ആദ്യം ഒരു സ്‌പ്രൈറ്റ് തിരഞ്ഞെടുക്കുക.",
    err_select_project: "ദയവായി ആദ്യം ഒരു പ്രോജക്റ്റ് തിരഞ്ഞെടുക്കുക.",
    err_name_empty: "പേര് ശൂന്യമാക്കാൻ കഴിയില്ല.",
    err_sprite_exists: "ആ പേരുള്ള ഒരു സ്പ്രൈറ്റ് ഇതിനകം നിലവിലുണ്ട്.",
    err_project_exists: "ആ പേരിൽ ഒരു പ്രോജക്റ്റ് ഇതിനകം നിലവിലുണ്ട്.",
    err_no_content: "സംരക്ഷിക്കാൻ ഉള്ളടക്കമില്ല.",
    err_no_changes: "സംരക്ഷിക്കാൻ മാറ്റങ്ങളൊന്നുമില്ല.",
    err_delete_last_sheet: "അവസാന ഷീറ്റ് ഇല്ലാതാക്കാൻ കഴിയില്ല.",
    err_extract_frames: "ഫ്രെയിമുകളൊന്നും എക്‌സ്‌ട്രാക്‌റ്റുചെയ്യാനായില്ല.",
    err_indexeddb: "പ്രാദേശികമായി സംരക്ഷിക്കുന്നതിൽ പരാജയപ്പെട്ടു. നിങ്ങളുടെ ബ്രൗസർ IndexedDB-യെ പിന്തുണച്ചേക്കില്ല.",
    msg_upload_success: "അപ്‌ലോഡ് വിജയകരം: {0}",
    msg_upload_failed: "അപ്‌ലോഡ് പരാജയപ്പെട്ടു: {0}",
    msg_save_success: "സംരക്ഷിക്കുക വിജയിച്ചു.",
    msg_saving: "സംരക്ഷിക്കുന്നു...",
    msg_multi_save_result: "സംരക്ഷിച്ച {0} അസറ്റുകൾ. {1} പരാജയങ്ങൾ.",
    menu_title: "മെനു",
    menu_save: "സംരക്ഷിക്കുക",
    menu_save_all: "എല്ലാം സംരക്ഷിക്കുക",
    menu_support: "പിന്തുണയുമായി ബന്ധപ്പെടുക",
    label_local_storage: "പ്രാദേശിക സംഭരണം",
    label_sign_in: "സൈൻ ഇൻ",
    modal_export_title: "സ്പ്രൈറ്റ് കയറ്റുമതി ചെയ്യുക",
    label_filename: "ഫയലിന്റെ പേര്",
    label_format: "ഫോർമാറ്റ്",
    action_export_confirm: "കയറ്റുമതി",
};

export default translations;
